module.exports = __webpack_public_path__ + "img/personal_details_green.cfa75b38.svg";